import { createTheme, colors } from '@material-ui/core';
import { plPL } from '@material-ui/core/locale';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#333333'
    },
    secondary: {
      main: '#d50000'
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
}, plPL);

export default theme;
